// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f623fdb","453":"30a5be07","667":"179daefb"}[chunkId] + ".chunk.js";
};